import { z } from 'zod';

export const DashboardRejectionGroupSchema = z.object({
    Id: z.number().optional(),
    ShortDescription: z.string().trim().min(1, 'Description is required'),
    Label: z.string().trim().min(1, 'Label is required'),
    LastUpdateDate: z.date().optional(),
    Rowversion: z.number().optional(),
});

export type DashboardRejectionGroupViewModel = z.infer<typeof DashboardRejectionGroupSchema>;
